import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as classesActions from '../../store/classes/actions';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';
import { ROUTES } from 'Settings/route-strings';

class CreateClassForm extends React.Component {
  constructor(props) {
    super(props);

    this.navigateToClassPage = this.navigateToClassPage.bind(this);
  }

  componentDidUpdate() {
    if (this.props.newClassId) {
      this.props.clearNewClassId();
      window.setTimeout(this.navigateToClassPage, 250, this.props.newClassId);
    }
  }

  navigateToClassPage(id) {
    this.props.history.push(`${ROUTES.CLASSES}/${id}`);
  }

  render() {
    const { teacherId, schoolId, inLightbox } = this.props;
    return (
      <Form
        type="createClass"
        id="createClass"
        submitArgs={{ teacher_ids: [parseInt(teacherId)], schoolId }}
        formStyle="createClass"
        messagePosition="lightbox-create-class"
        submitButtonType="primary"
        inLightbox={inLightbox}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    newClassId: reducers.getNewClassId(state),
    teacherId: state.users.activeUser.user.id,
    schoolId: reducers.getActiveSchoolId(state),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    ...classesActions,
  })(CreateClassForm)
);
